module.exports = __webpack_public_path__ + "img/shipo-itm-white-logo.4da3ceff.png";